import type { ReactNode } from 'react';
import { Heading } from '../atoms/Heading';
import styles from './AuthLayout.module.css';

export interface AuthLayoutProps {
  brand: ReactNode;
  title: string;
  /** One short sentence, only when the page needs it (e.g. after an e-mail link). */
  description?: ReactNode;
  footer?: ReactNode;
  /** Decorative layer behind the panel, only for pages that opt in (sign-in). */
  background?: ReactNode;
  children: ReactNode;
}

/**
 * Sign-in, password reset and invitations: logo, title and form on a plain
 * surface in the middle (docs/ux-richtlinien.md §6.14).
 */
export function AuthLayout({
  brand,
  title,
  description,
  footer,
  background,
  children,
}: AuthLayoutProps) {
  return (
    <div className={styles.page}>
      {background}
      <div className={styles.panel}>
        <div className={styles.brand}>{brand}</div>
        <main className={styles.card}>
          <div className={styles.heading}>
            <Heading level={1} size="2xl">
              {title}
            </Heading>
            {description && <div className={styles.description}>{description}</div>}
          </div>
          <div className={styles.body}>{children}</div>
        </main>
        {footer && <footer className={styles.footer}>{footer}</footer>}
      </div>
    </div>
  );
}
